import React from 'react';
import { storeData } from '../../data/storeData';
import StoreTemplate from '../../components/StoreTemplate';
import ankenyImg from '../../assets/images/ankenyoutside.jpg';

function Ankeny() {
    return <StoreTemplate storeData={storeData.ankeny} storeImage={ankenyImg} />;
}

export default Ankeny; 